const blocs = document.querySelectorAll(".flexAccordion__list")

for(const bloc of blocs) {

	const sections = bloc.querySelectorAll(".flexAccordion__list__item")

	for(const section of sections) {
		section.querySelector(".item__title").addEventListener("click", () => {
			section.classList.toggle("unfolded");
			[...sections].filter(section_ => section_ !== section).forEach(section_ => section_.classList.remove("unfolded"))
		})
		if(section.querySelector('.gform_validation_error') || section.querySelector('.gform_confirmation_wrapper')) {
			section.classList.add("unfolded");
		}
	}
}
